import { Auth } from "aws-amplify";
import { Buffer } from "buffer";
import { decodeFromBase64, encodeToBase64 } from "../functions/misc";

export const RedirectToLegacy = async (email: string, onClientPortal?: boolean | undefined) => {
  let jwt = async () => (await Auth.currentSession()).getIdToken().getJwtToken();

  jwt().then((token) => {
    let loginUrl = `${
      process.env.REACT_APP_LEGACY_CLIENT_PORTAL_URL
    }/login?Token=${token}&Email=${Buffer.from(email).toString("base64")}`;

    if (onClientPortal) {
      window.open(loginUrl, '_blank');
    } else {
      Auth.signOut().then(() => {
       window.location.href = loginUrl;
      });
    }
  });
};

let authenticatedToLegacyEventListener = false;

export const AuthenticatedToLegacy = async (email: string, newTab: boolean = false) => {
  let jwt = async () =>
    (await Auth.currentSession()).getIdToken().getJwtToken();
  jwt().then((token) => {
    const modifiedToken = insertAtPosition(token);

    if (!authenticatedToLegacyEventListener) {
      window.addEventListener('beforeunload', async () => {
        await Auth.signOut();
      });
      authenticatedToLegacyEventListener = true;
    }

    const legacyUrl = `${
      process.env.REACT_APP_LEGACY_CLIENT_PORTAL_URL
    }/one-web/login?Token=${modifiedToken}&Email=${encodeToBase64(email)}`;

    if (newTab) {
      window.open(legacyUrl, '_blank');
    } else {
      window.location.href = legacyUrl;
    }
  });
};

export const IsUserLegacy = async () => {
  const isUserLegacy = await Auth.currentAuthenticatedUser();
  return !!isUserLegacy.attributes["custom:LegacyProfileId"];
};

function insertAtPosition(token: string): string {
  const utcDate = new Date(new Date().toUTCString());
  const currentMonth = utcDate.getUTCMonth() + 1;
  let currentMonthStr = currentMonth.toString();
  if (currentMonth.toString().length !== 2) {
    currentMonthStr = "0" + currentMonthStr;
  }
  currentMonthStr = encodeToBase64(currentMonthStr);
  let value = "";
  currentMonth % 2 === 1 ? value = token + currentMonthStr : value = currentMonthStr + token;

  return value;
}

